import BaseComponent from '../../../base/base_component';
import DOM from '../../../utils/dom';
import _ from '../../../utils/underscore';
import {SYSTEM_EVENTS} from '../../../events/events';


let gameJackpotView = require('./view/game_jackpot.html');

export default class GameJackpotComponentController extends BaseComponent {
    static CLASS = 'GameJackpotComponentController';

    static DIRECTIVE = 'cgp-directive-game_jackpot';

    init(params) {
        params = params || {};
        params.innerHtml = gameJackpotView;
        this._gameType = params.gametypeid;

        super.init(params);
        this._subscribe();
    }

    start() {
        let jackpotValue = this.serviceFactory.jackpotFeedsService().getJackpotAmountInCentsByGame(this._gameType);
        this._displayJackpotValue(jackpotValue);
    }

    _subscribe() {
        this.onSystemEvent(SYSTEM_EVENTS.LIVE_FEEDS_JACKPOT_AMOUNTS_BY_GAME_UPDATED, this._onJackpotsUpdated);
    }

    get _liveFeedContentElement() {
        return this.querySelector('.cgp-live-feed-content');
    }

    _onJackpotsUpdated(gamesJackpots) {
        let jackpotValue = gamesJackpots[this._gameType];
        this._displayJackpotValue(jackpotValue);
    }

    _displayJackpotValue(jackpotValue) {
        if(!_.isNullOrUndefined(jackpotValue)) {
            DOM.text(this._liveFeedContentElement, this.serviceFactory.currencyService().formatMoney(jackpotValue));
        }
    }

    getPropertiesStyleMapper() {
        return {
            amount: 'cgp-live-feed-content'
        };
    }

}